import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div
      className={`pt-[40px] pb-[20px] text-[#fff] bg-[url('/Image/home/footer_background.webp')] bg-cover bg-center  w-full`}
    >
      <div className="container">
        <div className="flex border-b-[1px] border-[#282828] mb-[25px] max-md:flex-col">
          <div className="w-[30%] max-md:w-full">
            <div className="logo mb-[20px]">
              <img className="max-md:mx-auto" src="/Image/home/travomint_footer_logo.svg" alt="logo" width={144} />
            </div>
            <h2 className="max-md:text-center text-[18px] font-[600]">Disclaimer</h2>
            <p className="text-[12px] max-md:text-center font-[400] leading-[22px]">
            Travomint provides reliable and secure B2B travel portal solutions to our customers. We are not liable for any loss or harm caused by our products or services. All the logos, trademarks, and names available on the websites belong to their respective owners.
            </p>
          </div>
          {/* <ul className=" text-[14px]  font-[400] flex-1 list-none p-0 flex justify-evenly items-center">
            <li>
              <a className="text-[#fff] no-underline hover:text-[#CB2B2C]" href="#">About Us</a>
            </li>
            <li>
              <a className="text-[#fff] no-underline hover:text-[#CB2B2C]" href="#">Contact Us</a>
            </li>
            <li>
              <a className="text-[#fff] no-underline hover:text-[#CB2B2C]" href="#">Terms & Conditions</a>
            </li>
            <li>
              <a className="text-[#fff] no-underline hover:text-[#CB2B2C]" href="#">Privacy Policy</a>
            </li>
            <li>
              <a className="text-[#fff] no-underline hover:text-[#CB2B2C]" href="#">Partners Agreement</a>
            </li>
          </ul> */}
          <ul className="text-[14px] font-[400] flex-1 list-none p-0 flex justify-evenly items-center max-[590px]:flex-col max-[590px]:gap-[30px]">
            <li>
              <Link
                to="/about-us"
                className="text-[#fff] no-underline hover:text-[#CB2B2C]"
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/contact-us"
                className="text-[#fff] no-underline hover:text-[#CB2B2C]"
              >
                Contact Us
              </Link>
            </li>
            <li>
              <Link
                to="/termsAndConditions"
                className="text-[#fff] no-underline hover:text-[#CB2B2C]"
              >
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link
                to="/privacyPolicy"
                className="text-[#fff] no-underline hover:text-[#CB2B2C]"
              >
                Privacy Policy
              </Link>
            </li>

          </ul>
        </div>
        <div className="flex justify-between text-[12px] font-[500] max-[380px]:flex-col">
          <p className="max-[380px]:text-center">(Travomint.com is a legal entity of SNVA Group)</p>
          <p className="max-[380px]:text-center" >SNVA Group © All Right Reserved</p>
        </div>
        <div className="py-4">
          <div className="mx-auto grid grid-cols-3 max-[530px]:grid-cols-2  gap-4">
            <div className="bg-[#FFFFFF26] px-3 py-1 h-[66px] rounded-md border-[1px] border-dashed border-[#555555] flex items-center justify-center">
              <img
                src="/Image/home/footer_visa.svg"
                alt="Visa"
                className="max-w-[60%] md:max-w-full"
              />
            </div>

            <div className="bg-[#FFFFFF26] px-3 py-1 h-[66px]   rounded-md border-[1px] border-dashed border-[#555555] flex items-center justify-center">
              <img
                src="/Image/home/footer_mastercard.svg"
                alt="MasterCard"
                className="max-w-[60%] md:max-w-full"
              />
            </div>

            <div className="bg-[#FFFFFF26] px-3 py-1 h-[66px]   rounded-md border-[1px] border-dashed border-[#555555] flex items-center justify-center">
              <img
                src="/Image/home/footer_american_exp.svg"
                alt="American Express"
                className="max-w-[60%] md:max-w-full"
              />
            </div>

            <div className="bg-[#FFFFFF26] px-3 py-1 h-[66px]   rounded-md border-[1px] border-dashed border-[#555555] flex items-center justify-center">
              <img
                src="/Image/home/footer_discover.svg"
                alt="Discover"
                className="max-w-[60%] md:max-w-full"
              />
            </div>

            <div className="bg-[#FFFFFF26] px-3 py-1 h-[66px]   rounded-md border-[1px] border-dashed border-[#555555] flex items-center justify-center">
              <img
                src="/Image/home/footer_jcb.svg"
                alt="JCB"
                className="max-w-[60%] md:max-w-full"
              />
            </div>

            <div className="bg-[#FFFFFF26] px-3 py-1 h-[66px]   rounded-md border-[1px] border-dashed border-[#555555] flex items-center justify-center">
              <img
                src="/Image/home/footer_diners.svg"
                alt="Diners Club"
                className="max-w-[60%] md:max-w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
